/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".page-container[_ngcontent-%COMP%]   mat-card[_ngcontent-%COMP%]{margin:15px 0}.page-container[_ngcontent-%COMP%]   mat-card[_ngcontent-%COMP%]   a.link[_ngcontent-%COMP%]{color:#007bff;text-decoration:none;cursor:pointer}"];
export { styles as styles };
